export default "__VITE_ASSET__ecb833e5__"